const DOCUMENT_BODY_NOTE_TARGET = 'document_body';

export function noteNavigationTarget(note) {
  const target = (note && (note.path || note.category)) || '';
  return target === DOCUMENT_BODY_NOTE_TARGET ? '' : target;
}

export function notePersistenceAttributes(note) {
  if (!note) return null;

  return {
    parent_attribute: note.parent_attribute,
    category: note.category,
    path: note.path,
    text: note.text,
    raw_text: note.raw_text,
  };
}
